"use client"

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { 
  Search, 
  Download, 
  FileText, 
  Settings,
  Zap
} from "lucide-react"

const quickActions = [
  {
    label: "帳票検索",
    description: "アーカイブデータを検索",
    icon: Search,
    href: "/search",
  },
  {
    label: "一括ダウンロード",
    description: "選択したデータを出力",
    icon: Download,
    href: "/download",
  },
  {
    label: "レポート作成",
    description: "月次レポートを生成",
    icon: FileText,
    href: "/reports",
  },
  {
    label: "同期設定",
    description: "API連携設定の変更",
    icon: Settings,
    href: "/settings/sync",
  },
]

export function QuickActionsWidget() {
  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex items-center gap-2">
          <Zap className="h-5 w-5 text-primary" />
          <CardTitle className="text-base">クイックアクション</CardTitle>
        </div>
        <CardDescription>よく使う機能へのショートカット</CardDescription>
      </CardHeader>
      <CardContent className="grid grid-cols-2 gap-3">
        {quickActions.map((action) => (
          <Button
            key={action.label}
            variant="outline"
            className="h-auto flex-col items-start gap-2 p-4 hover:bg-secondary/80 bg-transparent"
            asChild
          >
            <a href={action.href}>
              <action.icon className="h-5 w-5 text-primary" />
              <div className="text-left">
                <p className="text-sm font-medium">{action.label}</p>
                <p className="text-xs text-muted-foreground font-normal">
                  {action.description}
                </p>
              </div>
            </a>
          </Button>
        ))}
      </CardContent>
    </Card>
  )
}
